type CompanyFeaturesAccessType = 'ALLOWED' | 'FORBIDDEN';

interface CompanyFeatureType {
  value: number[];
  type: CompanyFeaturesAccessType;
}

const COMPANY_FEATURES = {
  BOOK_UNREVIEWED_MATCHES: {
    value: [],
    type: 'FORBIDDEN'
  } as CompanyFeatureType, // use "as" here to allow to extract keys into the CompanyFeature type
  MICROBETTING_DEMO: {
    value: [],
    type: 'ALLOWED'
  } as CompanyFeatureType
};

type CompanyFeature = keyof typeof COMPANY_FEATURES;

export type { CompanyFeature, CompanyFeaturesAccessType };
export { COMPANY_FEATURES };
